import _ from 'lodash';
import { takeLatest, call, put, all } from 'redux-saga/effects';
import delay from '@redux-saga/delay-p';
import Form from './index.js';

/**
 * does the actual form 'save' using the api
 * @param saveAndClose - close after the save operation
 */
function* _saveForms(saveAndClose, forms) {
  try {
    if (forms.length > 0) {
      const [apiResult] = yield all([call(Form.Api.saveForms, forms), call(delay, 250)]);
      yield all(_.map(apiResult, (form) => put(Form.Actions.receiveUpdatedForm(form))));
    }
    yield put(Form.Actions.finishSaving());
    yield put(Form.Actions.saveFormsSuccess(saveAndClose));
  } catch (err) {
    yield put(Form.Actions.saveFormsFailure(err));
  }
}

function* saveForms({ payload: { unsavedLayouts } }) {
  yield call(_saveForms, true, unsavedLayouts);
}

function* applyForms({ payload: { unsavedLayouts } }) {
  yield call(_saveForms, false, unsavedLayouts);
}

function* fetchExperienceForm({ payload: { formId } }) {
  try {
    const forms = yield call(Form.Api.fetchExperienceForm, formId);
    yield put(Form.Actions.fetchFormsSuccess(forms));
  } catch (error) {
    yield put(Form.Actions.fetchFormsFailure(error));
  }
}

function* _createNewForm({ payload: { form } }) {
  try {
    const [apiResult] = yield all([call(Form.Api.createNewForm, form), call(delay, 250)]);
    const savedForm = apiResult[0];
    yield put(Form.Actions.receiveUpdatedForm(savedForm));
    yield put(Form.Actions.finishSaving());
    yield put(Form.Actions.createNewFormSuccess(savedForm.id));
  } catch (err) {
    yield put(Form.Actions.createNewFormFailure(err));
  }
}
function* fetchContainerForms({ payload: { containerRef, typeRef, subTypeRef } }) {
  try {
    const forms = yield call(Form.Api.fetchContainerForms, containerRef, typeRef, subTypeRef);
    yield put(Form.Actions.fetchFormsSuccess(forms));
  } catch (error) {
    yield put(Form.Actions.fetchFormsFailure(error));
  }
}

function* fetchLibraryForms({ payload: { offset, max } }) {
  try {
    const forms = yield call(Form.Api.fetchLibraryForms, offset, max);
    yield put(Form.Actions.fetchFormsSuccess(forms));
  } catch (error) {
    yield put(Form.Actions.fetchFormsFailure(error));
  }
}

export default function* formSagas() {
  yield all([
    takeLatest(Form.Actions.saveForms.getType(), saveForms),
    takeLatest(Form.Actions.applyForms.getType(), applyForms),
    takeLatest(Form.Actions.fetchExperienceForm.getType(), fetchExperienceForm),

    takeLatest(Form.Actions.createNewForm.getType(), _createNewForm),
    takeLatest(Form.Actions.fetchContainerForms.getType(), fetchContainerForms),
    takeLatest(Form.Actions.fetchLibraryForms.getType(), fetchLibraryForms),
  ]);
}
